import React from "react";
import { Link } from "react-router-dom";
import "./blog.css";



const BlogCard = ({ blog }) => {
    return (
        <div className="blog-card">
            <img src={blog.image} alt={blog.title} />
            <div className="blog-content">
                <h3>{blog.title}</h3>
                <div className="written-by fs-6">
                    {/* Written By:{" "} */}
                    {/* <Link to={`/writer/${blog.writer.slug}`} className="writer-link" style={{}}>
                        {blog.writer.name}
                    </Link> */}
                </div>
                {/* <p className="date">{blog.date}</p> */}
                <p>{blog.shortDesc}</p>
                <div className="read-more-btn-two">
                    <Link to={`/blog/${blog.slug}`} className="read-more-btn">
                        Read More&nbsp;
                        <i className="bx bx-chevrons-right"></i>
                    </Link>
                </div>

            </div>
        </div>
    );
};

export default BlogCard;
